import { proxy, useSnapshot } from 'valtio'

/**
 * Session-scoped descriptor of the current Custom Build run, passed from the
 * Route Optimization modal at dispatch time and read by the Build Progress
 * modal to render its "Optimization configuration" footer.
 *
 * Cleared (`null`) before the first Custom Build and after a build completes
 * or is discarded.
 */
export type BuildProgressConfig = {
  /** Human-readable label like "Fleet savings: Minimum drivers". */
  strategyLabel: string
}

type AtomShape = {
  config: BuildProgressConfig | null
}

export const buildProgressConfigAtom = proxy<AtomShape>({ config: null })

export const setBuildProgressConfig = (config: BuildProgressConfig | null) => {
  buildProgressConfigAtom.config = config
}

/** Non-React read — used to tell whether a Build Progress flow is currently active. */
export const getBuildProgressConfig = () => buildProgressConfigAtom.config

export const resetBuildProgressConfig = () => {
  buildProgressConfigAtom.config = null
}

export function useBuildProgressConfig() {
  const snapshot = useSnapshot(buildProgressConfigAtom)
  return snapshot.config
}
